export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-social-skype-8332555716ffa405a4221a52c92e4614.svg";